﻿module.exports = {
    bindings: {
        isLarge: '<',
        chapterCode: '<'
    },
    controller: scheduleBChapterNotesButtonController,
    templateUrl: 'texts/components/chapter-notes-button.html'
};

scheduleBChapterNotesButtonController.$inject = [
    'pdfViewerModal',
    'scheduleBDataService'
];

function scheduleBChapterNotesButtonController(pdfViewerModal, scheduleBDataService) {

    var vm = {
        showAnnotation: showAnnotation
    };

    function showAnnotation() {
        scheduleBDataService.getScheduleBPdfFile(vm.chapterCode)
            .then(function (fileUrl) {
                pdfViewerModal.show(fileUrl, 'Schedule B - Chapter ' + vm.chapterCode);
            }); 
    }


    return vm;

}